export default __webpack_public_path__ + "static/media/other.6d1b8a06.svg";